<template>
  <v-toolbar flat class="pl-sidebar__toolbar transparent" id="pl-sidebar-toolbar">
    <v-layout justify-center>
      <v-list-tile>
        <v-list-tile>
          <router-link to="/">
            <div v-if="hasPrevToken">
              <v-btn class="pl-btn_primary" @click="backToPrevToken">К основному профилю</v-btn>
            </div>
            <div v-else>
              <img v-if="!this.mini" src="@/assets/main-logo.svg" width="140px" height="80px" />
              <img v-else src="@/assets/main-logo-min.svg" width="40px" height="40px" />
            </div>
          </router-link>
        </v-list-tile>
      </v-list-tile>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { isImpersonating } from '@/helpers/impersonate-utils'

export default {
  name: 'Toolbar',
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasPrevToken() {
      return isImpersonating()
    },
  },
  methods: {
    backToPrevToken() {
      const prevToken = localStorage.getItem('prevUserToken')
      localStorage.setItem('token', prevToken)
      localStorage.removeItem('prevUserToken')
      location.reload()
    },
  },
}
</script>
